import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { OrderItem, OrderItemStatus } from 'src/interfaces/order-item';
import { MatSelectChange } from '@angular/material/select';
import { LoaderService } from 'src/core/services/loader.service';
import { BatchStatus } from 'src/interfaces/batch';
import { DirtinessService } from 'src/core/services/dirtiness.service';
import { BatchService } from 'src/core/services/batch.service';
import { Order } from 'src/interfaces/order';
import { OrderStatus } from 'src/interfaces/order-status';

@Component({
  selector: 'core-order-item-list',
  templateUrl: './order-item-list.component.html',
  styleUrls: ['./order-item-list.component.scss']
})
export class OrderItemListComponent implements OnInit, OnChanges {

  displayedColumns: string[] = [
    'pack_size',
    'quantity',
    'name',
    'dosage',
    'status',
    'price',
    'remove'
  ];

  @Input() orderItems: OrderItem[];
  @Input() order: Order;
  @Input() orderItemStatuses: OrderItemStatus[] = [];
  @Input() batchStatuses: BatchStatus[] = [];
  @Input() orderStatus: OrderStatus | null = null;
  newBatchStatusCode: string = "AWM";
  statusCodes: {
    awaitingFulfilment: string,
    awaitingManufacture: string,
    inStock: string,
    procured: string,
    packed: string,
  } = {
      awaitingFulfilment: "AWF",
      awaitingManufacture: "AWM",
      inStock: "ISK",
      procured: "PRC",
      packed: "PKD",
    };
  @Output() onDelete = new EventEmitter<OrderItem>();
  isLoading: boolean = false;
  selectedItem: OrderItem | null = null;


  constructor(
    private _loaderService: LoaderService,
    private _dirtinessService: DirtinessService,
    private _batchService: BatchService
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.orderStatus) {
      if (this.orderStatus.code === 'SHP') {
        this.displayedColumns = this.displayedColumns.filter(column => column !== 'remove');
      } else {
        if(!this.displayedColumns.includes('remove'))
        this.displayedColumns.push('remove');
      }
    }
  }

  ngOnInit(): void {
    this
      ._loaderService
      .isLoading
      .subscribe(isLoading => {
        this.isLoading = isLoading;
      });

    if (this.orderStatus) {
      if (this.orderStatus.code === 'SHP') {
        this.displayedColumns = this.displayedColumns.filter(column => column !== 'remove');
      }
    }

  }

  deleteOrderItem(item: OrderItem) {
    this.onDelete.emit(item);
  }

  changeOrderItemStatus(event: MatSelectChange, orderItem: OrderItem) {
    this._dirtinessService.setDirty(true);
    orderItem.status = event.value;
  }

  getTotalPrice(item: OrderItem): number {
    return item.medicineDosagePackageType.price * item.quantity;
  }

  getStatus(orderItem: OrderItem) {
    const orderItemStatus: OrderItemStatus | undefined = this
      .orderItemStatuses
      .find((orderItemStatus: OrderItemStatus) => {
        if (!orderItem.status) return false;
        return orderItemStatus.id === orderItem.status.id;
      })
    if (!orderItemStatus) return null;
    return orderItemStatus;
  }

  disableStatus(status: OrderItemStatus): boolean {
    return (
      status.code === 'PRC'
      ||
      status.code === 'PKD'
    )
  }

  async printLabels(orderItems: OrderItem[]) {

    const success: boolean = await this._batchService
      .openPrintLabelsDialog(
        "Print labels",
        "Click the 'Print' button to start printing.",
        orderItems,
        this.order
      );
  }

  async printAllLabels() {
    const success: boolean = await this._batchService
      .openPrintLabelsDialog(
        "Print labels",
        "Click the 'Print' button to start printing.",
        this.orderItems,
        this.order
      );
  }

}
